// extracted by mini-css-extract-plugin
export default {"menuBlock":"DG-z","title":"EG-z","nav":"FG-z","flexCell":"GG-z","facetLink":"HG-z"};